import MyEnum from '@/common/MyEnum'
import { enumValue } from '@/common/EnumValue'
import { BaseModel } from '@/models/BaseModel'

export { cycleMap } from '@/views/data/mixin'

export class ROLE_TYPE_ENUM extends MyEnum {
  static COMPANY = enumValue(1, '厂牌')
  static BUSINESS = enumValue(2, '商务')
  static LEGAL = enumValue(3, '法务')
  static EDITOR = enumValue(4, '编务')
  static OTHER = enumValue(5, '其他')
  static FINANCE = enumValue(6, '财经')

  // 第三方投诉身份
  static PRIVATE = enumValue(7, '个人版权申诉')
  static ORGANIZATION = enumValue(8, '组织版权申诉')

  static AI_PUBLISH = enumValue(9, 'AI发行')
}

export class SIGN_STATUS extends MyEnum {
  static UNSIGN = enumValue(0, '未签约')
  static SIGNED = enumValue(1, '已签约')
}

export const isRelateMap = {
  0: '无关联',
  1: '有关联'
}

export const companyRoleMap = {
  1: '母厂牌',
  2: '子厂牌',
  3: '其他'
}

export class Company extends BaseModel {
  roleType = ROLE_TYPE_ENUM.COMPANY.code
  channelId = 0
  companyName = ''
  email = ''
  cpAddress = ''
  phoneNum = ''
  corporation = ''
  companyDesc = ''
  companyLicenseList = []
  copyrightCompany = {
    companyName: ''
  }

  companyPhotoList = []
  relateCompanyList = []
  agentCompanyList = []
  qqNum = ''
  signStatus = 0
  productionList = []
  companyRole = 1
  isRelate = 0
  checkInfo = ''

  // 兼容需要默认值
  idCodeType = 0
  idCode = ''

  constructor(initObj) {
    super()

    this._collectProperties()

    if (initObj) {
      this._setValues(initObj)

      this.init(initObj)
    }
  }

  init(initObj) {
    this.roleType = ROLE_TYPE_ENUM.COMPANY.code
    this.agentCompanyList = initObj.agentCompanyList?.map(item => {
      item.tempId = item.agentCompanyId
      return item
    }) ?? []
  }

  getBackendData() {
    const postData = super.getBackendData()

    if (postData.isRelate === 0 || (postData.isRelate === 1 && postData.companyRole === 1)) {
      postData.copyrightCompany.companyName = postData.companyName
    }

    postData.copyrightCompanyList = [postData.copyrightCompany]
    // 保留填了名字的项
    postData.agentCompanyList = postData.agentCompanyList.filter(item => item.agentCompanyName)

    return postData
  }
}

export class Editor extends BaseModel {
  roleType = ROLE_TYPE_ENUM.EDITOR.code
  rtxName = ''
  email = ''
  cpAddress = ''
  phoneNum = ''
  corporation = ''

  agentCompanyList = []
  relateCompanyList = []
  qqNum = ''
  signStatus = 0
  checkInfo = ''

  constructor(initObj) {
    super()

    this._collectProperties()

    if (initObj) {
      this._setValues(initObj)

      this.init(initObj)
    }
  }

  init(initObj) {
    this.relateCompanyList = initObj.relateCompanyList?.map(item => {
      item.tempId = item.relateCompanyId
      return item
    }) ?? []
  }

  getBackendData() {
    const postData = super.getBackendData()

    postData.relateCompanyList = postData.relateCompanyList.filter(item => item.relateCompanyName)

    return postData
  }
}

export class Organization extends BaseModel {
  roleType = ROLE_TYPE_ENUM.ORGANIZATION.code
  // 主体信息
  companyName = ''
  socialCreditCode = ''

  companyLicenseList = []
  socialCreditCode = ''
  corporation = ''

  // 联系人信息
  name = ''
  phoneNum = ''
  email = ''
  cpAddress = ''
  postalcode = ''
  qqNum = ''

  // 一些必传的默认值
  signStatus = 0
  isRelate = 0
  companyRole = 0
  idCodeType = 0
  idCode = ''

  constructor(initObj) {
    super()
    this._collectProperties()

    if (initObj) {
      this._setValues(initObj)

      this.init(initObj)
    }
  }

  init(initObj) {
    this.roleType = ROLE_TYPE_ENUM.ORGANIZATION.code
  }

  getBackendData() {
    const postData = super.getBackendData()

    return postData
  }
}

export class Private extends BaseModel {
  roleType = ROLE_TYPE_ENUM.PRIVATE.code
  // 主体信息
  companyName = '' // 真实姓名
  idCodeType = ''
  idCode = ''
  phoneNum = ''
  email = ''
  cpAddress = ''
  qqNum = ''

  userIdentifyList = []

  // 一些必传的默认值
  signStatus = 0
  isRelate = 0
  companyRole = 0
  companyLicenseList = []

  constructor(initObj) {
    super()

    Object.values(ID_FILE_KEY_TYPE_ENUM.codeNameMap).forEach(type => {
      this[`${type}List`] = []
    })

    this._collectProperties()

    if (initObj) {
      this._setValues(initObj)

      this.init(initObj)
    }
  }

  init(initObj) {
    this.roleType = ROLE_TYPE_ENUM.PRIVATE.code

    if (Array.isArray(initObj.userIdentifyList)) {
      initObj.userIdentifyList.forEach(file => {
        const type = ID_FILE_KEY_TYPE_ENUM.codeNameMap[file.fileType]
        file.name = file.fileName
        this[`${type}List`] = [file]
      })
    }
  }

  getBackendData() {
    const postData = super.getBackendData()
    postData.userIdentifyList = []
    Object.values(ID_FILE_KEY_TYPE_ENUM.codeNameMap).forEach(type => {
      postData.userIdentifyList.push(postData[`${type}List`].pop())
      postData[`${type}List`] = undefined
    })

    return postData
  }
}

export class AIPublish extends BaseModel {
  roleType = ROLE_TYPE_ENUM.AI_PUBLISH.code
  realName = ''
  idType = 1
  idNum = ''
  phoneNum = ''
  email = ''
  qqNum = ''
  singerType = 1
  singerName = ''
  singerPhotoList = []
  identityFileList = [] // 虚拟身份证明
  worksCaptureList = [] // 作品截图
  aiTools = ''
  area = 6
  // genre = 1
  desc = ''

  constructor(initObj) {
    super()

    this._collectProperties()

    if (initObj) {
      this._setValues(initObj)

      this.init(initObj)
    }
  }

  init(initObj) {
    this.roleType = ROLE_TYPE_ENUM.AI_PUBLISH.code
  }

  getBackendData() {
    const postData = super.getBackendData()
    return postData
  }
}

// 文件类型需要修改
export class ID_FILE_KEY_TYPE_ENUM extends MyEnum {
  static FRONT = enumValue(0, 'front')
  static BACK = enumValue(1, 'back')
  static HAND = enumValue(2, 'hand')
}

// 证件类型
export const IDTypeMap = {
  1: '身份证',
  2: '护照（仅限非中国大陆户籍用户入驻提交）',
  3: '台胞证',
  4: '港澳居民来往内地通行证',
}

export const singerTypeMap = {
  1: {
    name: 'AI 虚拟艺人',
    desc: '我有虚拟人设，希望打造一个风格比较统一的虚拟艺人'
  },
  2: {
    name: 'AI 创作者',
    desc: '我没有虚拟人设，只是作为创作者自由发布自己的 AI作品'
  }
}
